import React from "react";
import { useSelector } from "react-redux";
import Search from "../../images/search.svg";
import "./AdminTableFilterHeader.scss";
import { Box, Button, Typography, TextField } from "@mui/material";

function AdminTableFilterHeader({ setSearchText, handleOpen, searchText }) {
  const portalList = useSelector((state) => state.portalUsers.portalUsers);

  const handleInputChange = (event) => {
    const inputText = event.target.value;
    setSearchText(inputText);
  };

  return (
    <Box className="options-container">
      <Box
        className="search-container"
        // sx={{
        //   display: 'flex',
        //   alignItems: 'center',
        //   borderRadius: '33px',
        //   border: '1px solid #D1D5DB',
        //   padding: '0 10px',
        //   background: '#F9FAFB',
        // }}
      >
        <TextField
          placeholder="Search Admin"
          value={searchText}
          onChange={handleInputChange}
          variant="standard"
          fullWidth
          InputProps={{
            disableUnderline: true, 
            sx: {
              borderRadius: '33px',
              color: '#000',
            },
            endAdornment: (
              <img
                src={Search}
                alt="Search Icon"
                style={{ paddingLeft: '5px' }} 
                loading="lazy"
              />
            ),
          }}
          sx={{
            '& .MuiInputBase-root': {
            },
            '& .MuiInputBase-input': {
              fontSize: '14px',
            },
          }}
        />
      </Box>

      <Button
        className="new-user-button"
        onClick={handleOpen}
        sx={{
          borderRadius: "33px",
          background: "#3bc97b",
          border: "none",
          display: "flex",
          color: "white",
          alignItems: "center",
          padding: "0px 17px 0px 25px",
          height: "40px",
          '&:hover': {
            background: "#35b06c",
          },
        }}
      >
        <Typography>Add New</Typography>
        <Box>+</Box>
      </Button>
    </Box>
  );
}

export default AdminTableFilterHeader;
